export enum PaymentMethod {
  CreditOrDebit = 'CreditOrDebit',
  CashOrCheck = 'CashOrCheck',
}
